module.exports = __webpack_public_path__ + "static/media/insta6.0a69a1c0.jpg";